export default __webpack_public_path__ + "b7a6382c37af63d26e8f7ce51ce4f220.gif";